let alldata = {
  index: {
    navarr: [{
      id: 1,
      name: '首页',
      url: '/home'
    },
    // {
    //   id: 2,
    //   name: '产品介绍',
    //   url: '/product'
    // },
    {
      id: 3,
      name: '业务招募',
      url: '/business'
    },
    {
      id: 4,
      name: '下载中心',
      url: '/download'
    },
    {
      id: 5,
      name: '教程',
      url: '/Course'
    },
      // {
      //   id: 6,
      //   name: '品牌定制',
      //   url: '/brand'
      // },
    ],
    servicearr: [{
      id: 1,
      name: '7x24小时服务支撑'
    },
    {
      id: 2,
      name: '装完即跑 快速赚钱'
    },
    {
      id: 3,
      name: '产品多样化'
    },
    {
      id: 4,
      name: '1v1客户专享服务'
    },
    ],//底部服务
    qrarr: [
      {
        id: 1,
        name: '官方交流群',
        img: 'https://oss.jinchaoshuju.com/images/985616d2-2a62-4e69-977b-2528cf7072af.png'
      },
      {
        id: 2,
        name: '上机商务1',
        img: 'https://oss.jinchaoshuju.com/images/8b71384e-a136-4ee3-8c0e-54faf5935f3a.png'
      },
      {
        id: 3,
        name: '上机商务2',
        img: 'https://oss.jinchaoshuju.com/images/0032a4e2-ac6f-4385-ad2d-5d3581c40c9d.png'
      },
      {
        id: 4,
        name: '上机商务3',
        img: 'https://oss.jinchaoshuju.com/images/a50b6fb1-7a4d-4419-ae06-5d361c995bcc.png'
      },
      {
        id: 5,
        name: '上机商务4',
        img: 'https://oss.jinchaoshuju.com/images/5a2b6fd1-71e3-48c2-a4b1-09d5ba93361d.png'
      },
    ],//底部二维码
  },
  // home: {
  //   bannerarr: [{
  //       id: 1,
  //       title: '多元化智能硬件',
  //       subtitle: '闲置带宽、存储和算力的共享边缘计算运营平台',
  //       img: require('../assets/index/ban_02.jpg')
  //     },
  //     {
  //       id: 2,
  //       title: '全球边缘计算创领者',
  //       subtitle: '创新融合共享经济和边缘云技术，汇聚百万级节点资源，开创边缘计算时代',
  //       img: require('../assets/index/ban_05.jpg')
  //     },
  //     {
  //       id: 3,
  //       title: '边缘计算',
  //       subtitle: '基于Docker技术开放百万级节点资源，支持对带宽、算力、存储资源的深度使用',
  //       img: require('../assets/index/ban_02.jpg')
  //     },
  //     {
  //       id: 4,
  //       title: '函数计算',
  //       subtitle: '高效、轻量、便捷的无服务器应用，海量节点轻松打造真实测试环境',
  //       img: require('../assets/index/ban_05.jpg')
  //     },
  //     {
  //       id: 5,
  //       title: 'CDN共享版',
  //       subtitle: '开放百万级共享节点资源，完美兼容第三方CDN，帮助用户节省50%以上带宽成本',
  //       img: require('../assets/index/ban_02.jpg')
  //     },
  //     {
  //       id: 6,
  //       title: '星域通道',
  //       subtitle: '基于百万级节点，提供P2P网络穿透服务以及服务端/用户端到分布式节点之间的数据传输服务。',
  //       img: require('../assets/index/ban_05.jpg')
  //     },
  //   ],//首页banner图
  //   numarr: [{
  //       num: 10000,
  //       unit: '+',
  //       title: '节点数量'
  //     },
  //     {
  //       num: 200,
  //       unit: 'PB+',
  //       title: '存储空间'
  //     },
  //     {
  //       num: 100,
  //       unit: 'T+',
  //       title: '储存宽带'
  //     },
  //   ], //黑色-节点数量数据
  //   gongxiangarr: [{
  //       id: 1,
  //       title: '',
  //       list: [{
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },

  //       ],
  //       bttitle: '闲置带宽 现金激励',
  //       btvalue: '在移动、电信、联通运营商的带宽环境下，在您家庭宽带闲置时可以让您获得现金收益。',
  //       bgimg: require('../assets/index/rankbg1.jpg'),
  //     },
  //     {
  //       id: 2,
  //       title: '',
  //       list: [{
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //       ],
  //       bttitle: '贡献越多 收益越高',
  //       btvalue: '采用现金的方式进行激励， 激励额度根据用户实际贡献的上行流量进行结算。',
  //       bgimg: require('../assets/index/rankbg2.jpg'),
  //     },
  //     {
  //       id: 3,
  //       title: '',
  //       list: [{
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },

  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //         {
  //           value: '8ea7*******5d76',
  //           num: '685.89元'
  //         },
  //       ],
  //       bttitle: '实时看收益 周周提现金',
  //       btvalue: '下载APP，随时查看设备收益，实时监控设备在线情况，支持每周二提取收益现金至支付宝/银行卡。',
  //       bgimg: require('../assets/index/rankbg3.jpg'),
  //     },

  //   ], //共享限制数据
  //   meritarr: [{
  //       id: 1,
  //       title: '多平台定制',
  //       value: 'APP | IOS | Android | 微信 | PC | 手机站 | 微商城',
  //       img: require('../assets/index/img1.png'),
  //       icon: require('../assets/index/ii1_01.png'),
  //       iconcurrent: require('../assets/index/ii1_02.png')
  //     },
  //     {
  //       id: 2,
  //       title: '高效技术开发',
  //       value: '原型策划 | Ui设计 | 程序开发 | 系统测试 | 质量监督 | 迭代运维',
  //       img: require('../assets/index/img2.png'),
  //       icon: require('../assets/index/ii2_01.png'),
  //       iconcurrent: require('../assets/index/ii2_02.png')
  //     },
  //     {
  //       id: 3,
  //       title: '成熟系统构架',
  //       value: 'Linux系统 | Apaeche、Nginx 服务器PHP/java/Nodejs',
  //       img: require('../assets/index/img3.png'),
  //       icon: require('../assets/index/ii3_01.png'),
  //       iconcurrent: require('../assets/index/ii3_02.png')
  //     },
  //     {
  //       id: 4,
  //       title: '服务器方案',
  //       value: '分布式数据库服务器 | 大数据负载 | 全球节点接入',
  //       img: require('../assets/index/img4.png'),
  //       icon: require('../assets/index/ii4_01.png'),
  //       iconcurrent: require('../assets/index/ii4_02.png')
  //     },
  //     {
  //       id: 5,
  //       title: '全程服务支持',
  //       value: '售前咨询 | 需求分析 | 团队建设 | 问题处理 | 售后支持 | 迭代建议',
  //       img: require('../assets/index/img5.png'),
  //       icon: require('../assets/index/ii5_01.png'),
  //       iconcurrent: require('../assets/index/ii5_02.png')
  //     },
  //   ], //公司优势数据
  //   newsarr: [{
  //       id: 1,
  //       value: '金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //     {
  //       id: 2,
  //       value: '金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //     {
  //       id: 3,
  //       value: '金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //     {
  //       id: 4,
  //       value: '金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //     {
  //       id: 5,
  //       value: '金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //     {
  //       id: 6,
  //       value: '金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //     {
  //       id: 7,
  //       value: '7金巢数据有限公司自主研发分布式边缘计算平台，将C端用户闲置的计算、存储、宽带等资源连接成一张边缘计算网络，为B端企业提供优质、高效、低成本的边缘计算服务。',
  //       time: '2023-03-15',
  //     },
  //   ], //新闻列表数据
  //   zizhiarr: [{
  //       id: 1,
  //       img: require('../assets/index/zizhi1.jpg'),
  //       type: '竖版',
  //       title: '数博会领先科技成功奖1'
  //     },
  //     {
  //       id: 2,
  //       img: require('../assets/index/zizhi2.jpg'),
  //       type: '横版',
  //       title: '数博会领先科技成功奖2'
  //     },
  //     {
  //       id: 3,
  //       img: require('../assets/index/zizhi3.jpg'),
  //       type: '横版',
  //       title: '数博会领先科技成功奖3'
  //     },
  //     {
  //       id: 4,
  //       img: require('../assets/index/zizhi1.jpg'),
  //       type: '竖版',
  //       title: '数博会领先科技成功奖4'
  //     },
  //     {
  //       id: 5,
  //       img: require('../assets/index/zizhi2.jpg'),
  //       type: '横版',
  //       title: '数博会领先科技成功奖5'
  //     },
  //   ],//公司资质列表
  //   titlearr: [{
  //       id: 1,
  //       title: '公司简介',
  //       subtitle: '金巢数据是一家专注于使用自主可控的核心技术构建跨越“云-边-端”的全栈边缘计算服务平台，为企业提供边缘计算一站式软硬件开发解决方案，致力于为客户提供高效、稳定、安全的边缘计算服务，满足不同行业应用的需求。帮助客户在数字化转型和智能化发展中获得更大的成功。'
  //     },
  //     {
  //       id: 2,
  //       title: '一站式边缘计算服务商',
  //       subtitle: '金巢数据有限公司自主研发金巢云分布式边缘计算平台,将C端用户闲置的计算存储、宽带等资源连接成一张边缘计算网络,为B端企业提供优质、高效、低成本的边缘计算服务。'
  //     },
  //     {
  //       id: 3,
  //       title: '共享闲置资源，获取现金收益',
  //       subtitle: ''
  //     },
  //     {
  //       id: 4,
  //       title: '一站式边缘计算品牌孵化',
  //       subtitle: '专业一对一品牌定制，为客户提供软硬件一站式边缘计算服务和解决方案。'
  //     },
  //     {
  //       id: 5,
  //       title: '品牌新闻 | 行业动态 ',
  //       subtitle: '1000000+以上高级人才数据库'
  //     },
  //     {
  //       id: 6,
  //       title: '公司资质',
  //       subtitle: '1000000+以上高级人才数据库'
  //     },



  //   ],//主页各个大标题
  // },//首页数据
  product: {
    bannerarr: [{
      id: 1,
      name: '多元化智能硬件',
      value: '闲置带宽、存储和算力的共享边缘计算运营平台',
      img: require('../assets/product/banner2.jpg')
    },], //产品banner图数据
    productarr: [

      {
        id: 1,
        title: 'OES',
        value: '性能升级 | 全民共享',
        value2: '',
        list: [{
          value: '百万节点 全新旗舰',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '性能升级 功耗更低',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '灵便轻巧 轻松装盘',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '千兆网络 最优选择',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/工控机.png')
      },
      {
        id: 2,
        title: 'OEC',
        value: '赋能边缘算力，同创科技价值',
        value2: '高性能 | 高收益 | 低能耗',
        list: [{
          value: '硬件升级 强化性能',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '超低功耗 绿色节约',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '带宽拓展 收益加倍',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '轻松管理 乐享收益',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/盒子.png'),
      },
      {
        id: 3,
        title: '玩客云',
        value: '畅快下载的私人云盘',
        value2: '全新一代共享计算智能硬件',
        list: [{
          value: '高速下载',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '手机扩容',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '多屏互动',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '隐私加密',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/净化器.png')
      },
      {
        id: 4,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/路由器.png')
      },
      {
        id: 4,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/路由器.png')
      },
      {
        id: 5,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/路由器组装.png')
      },
      {
        id: 6,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/摄像头.png')
      },
      {
        id: 7,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/摄像头1.png')
      },
    ],//产品列表
  },//产品介绍
  business: {
    businessarr: [
      {
        id: 1, title: 'V聚合业务', value: '多线聚合，节省资源',
        img: require('../assets/icons/1.png'),
        iconcolor: '#FAC37E'
      },
      {
        id: 2, title: '定向业务', value: '定向业务下发，调度稳定',
        img: require('../assets/icons/3.png'),
        iconcolor: '#01C567'
      },
      {
        id: 3, title: '小水管业务', value: '单线单机，简单上手',
        img: require('../assets/icons/2.png'),
        iconcolor: '#667CFA'
      },
      {
        id: 5, title: '更多业务', value: '极客首选，自由编排',
        img: require('../assets/icons/5.png'),
        iconcolor: '#999999'
      },

    ],
  },//业务招募

}
export default alldata;
